<template>
    <div id="contenedor-editar-minuta">
        <v-form v-model="formularioValido" ref="editarMinuta">
          <v-card flat>
            <v-card-title class="secondary--text mb-4">
            Editar Minuta
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
                <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
            </v-card-title>
            <v-card-subtitle>
            </v-card-subtitle>
            <v-card-text>
                <v-row dense class="" style="">
                <v-col cols="12" md="6" class="">
                  <custom-text-field
                  cols="6"
                  class=""
                  v-model="minuta.numero"
                  label="Número"
                  :rules="[mixReglas.requerido]"
                  >
                  </custom-text-field>
                </v-col>
              </v-row>
              <v-row dense class="" style="">
                <v-col cols="12" md="6" class="">
                  <custom-date-picker
                  v-model="minutaFecha"
                  label="Fecha"
                  :rules="[mixReglas.requerido]">
                  </custom-date-picker>
                </v-col>
                <v-col cols="12" md="6">
                  <custom-select
                  v-model="minutaHora"
                  label="Hora"
                  :items="horas"
                  :rules="[mixReglas.requerido]">
                  </custom-select>
                </v-col>
              </v-row>
              <custom-text-field
                cols="12"
                class=""
                v-model="minuta.lugar"
                label="Lugar"
                :rules="[mixReglas.requerido]"
                >
              </custom-text-field>
              <custom-text-area
                cols="12"
                v-model="minuta.objetivo"
                label="Objetivo"
                rows="3"
                :rules="[mixReglas.requerido]">
              </custom-text-area>
            </v-card-text>
            <v-divider class="bkground" />
            <v-card-actions>
                <v-spacer></v-spacer>
                <custom-button
                    @click="cerrar"
                    tipo="formCancelar"
                    label="Cancelar"
                    class="mr-3">
                </custom-button>
                <custom-button
                    @click="guardar"
                    tipo="formAceptar"
                    label="Guardar"
                    :disabled="!formularioValido ||
                    enviandoFormulario "
                    :loading="enviandoFormulario"
                    >
                </custom-button>
            </v-card-actions>
          </v-card>
        </v-form>

    </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import mixMinutas from './mixMinutas';

export default {
  name: 'EditarMinuta',
  props: {
    minutaEditar: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixMinutas],
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      horas: this.getHorasList(),
      minutaFecha: '',
      minutaHora: '',
      minuta: {
        numero: this.minutaEditar.numero,
        fechaHora: '',
        lugar: this.minutaEditar.lugar,
        objetivo: this.minutaEditar.objetivo,
      },
    };
  },
  components: {
    CustomButton,
    CustomDatePicker,
    CustomTextArea,
    CustomTextField,
    CustomSelect,
  },
  mounted() {
    this.minutaFecha = this.splitFechaHora()[0] || '';
    this.minutaHora = this.splitFechaHora()[1].slice(0, 5) || '';
  },
  methods: {
    limpiarFormulario() {
      this.$refs.editarMinuta.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    async guardar() {
      this.minuta.fechaHora = this.getFechaHora();
      await this.mixActualizarMinuta();
    },
    splitFechaHora() {
      const fechaHora = this.minutaEditar.fechaHora.split('T');
      return fechaHora;
    },
    getFechaHora() {
      const fechaHora = `${this.minutaFecha} ${this.minutaHora}:00.999+0000`;
      return fechaHora;
    },
    getHorasList() {
      const horas = [];
      const horaInicio = 7;
      const horaFin = 19;
      for (let hora = horaInicio; hora <= horaFin; hora += 1) {
        horas.push(`${hora.toString().padStart(2, '0')}:00`);
        horas.push(`${hora.toString().padStart(2, '0')}:30`);
      }
      return horas;
    },
  },
};
</script>
